import React, { memo } from 'react'
import Avatar from '@jimmyboys/liita-ui/dist/components/Avatar'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import ReactMarkdown from 'react-markdown'
import breaks from 'remark-breaks'

import styles from './FinalSituationCard.module.sass'

const FinalSituationCard = memo(
	(props) => {
		const { className, data, ...attributes } = props
		const labels = data.$cardLabels || {}

		return (
			<div
				{...attributes}
				className={`card ${styles['root'] || ''} ${className || ''} ${
					styles[`${data?.$layout}-layout`] || ''
				}`}
			>
				<span className={styles['status-circle']} />
				<div className={styles['header-content']}>
					<span>
						<h5>
							<Icon
								className={styles['text-icon']}
								name='calendar'
								width='14px'
								height='14px'
							/>
							{data.date?.dateTimeFormat}
						</h5>
						<small>{data.disability?.name}</small>
					</span>
					<div className={`${styles['status-container']}`}>
						<div>
							<h5>{data?.doctor?.name}</h5>
							<small>{labels.ippForecast}</small>
						</div>
						<span className={styles['avatar-container']}>
							<Avatar
								rounded
								className={styles['avatar']}
								user={data?.doctor}
							/>
						</span>
					</div>
				</div>
				{data.$detailLevel !== 'summary' && (
					<div className={styles['inner-table']}>
						<span className={styles['cell']}>
							<h6>
								{data.expectedSituation
									? data.expectedSituation?.biologicalDamage
										? labels.biologicalDamage
										: labels.PPD
									: '-'}
							</h6>
							{data.expectedSituation?.weight ? (
								<small>
									{
										data.expectedSituation
											?.permanentPartialDisabilityRate
									}
									%x{data.expectedSituation?.weight}=
									{
										data.expectedSituation
											?.permanentPartialDisabilityRateFinal
									}
									%
								</small>
							) : !data.expectedSituation?.biologicalDamage ? (
								<small>-</small>
							) : null}
							{data.expectedSituation?.biologicalDamage ? (
								<small>
									{data.expectedSituation?.biologicalDamage ||
										'-'}
								</small>
							) : null}
						</span>
						<span className={styles['cell']}>
							<h6>{data.expectedSituation ? labels.TTD : '-'}</h6>
							<small>
								{data.expectedSituation
									?.temporaryTotalDisabilityDays || '-'}
							</small>
						</span>
						<span className={styles['cell']}>
							<h6>
								{data.expectedSituation ? labels.PTDOW : '-'}
							</h6>
							<small>
								{data.expectedSituation
									?.isPermanentTotalDisabilityForOrdinaryWork
									? labels.yes
									: data.expectedSituation
											?.isPermanentTotalDisabilityForOrdinaryWork ===
									  false
									? labels.no
									: '-'}
							</small>
						</span>
						<span className={styles['cell']}>
							<h6>
								{data.expectedSituation
									? labels.additionalEfforts
									: '-'}
							</h6>
							<small>
								{data.expectedSituation?.additionalEfforts
									? labels.yes
									: data.expectedSituation
											?.additionalEfforts === false
									? labels.no
									: '-'}
							</small>
						</span>
						<span className={styles['cell']}>
							<h6>
								{data.expectedSituation
									? labels.treatmentDays
									: '-'}
							</h6>
							<small>
								{data.expectedSituation?.treatmentDays || '-'}
							</small>
						</span>
					</div>
				)}
				{data.$detailLevel !== 'summary' && data.body && (
					<div className={styles['content']}>
						<h5>{labels.medicalObservation}</h5>
						<div dynamic='true' className={styles['comment-body']}>
							<div
								style={{
									minHeight:
										!isNaN(data.textHeight) &&
										data.textHeight > 0
											? data.textHeight
											: undefined,
									maxHeight:
										!isNaN(data.textHeight) &&
										data.textHeight > 0
											? data.textHeight
											: undefined,
								}}
							>
								<ReactMarkdown
									plugins={[breaks]}
									allowedTypes={[
										'break',
										'paragraph',
										'strong',
										'text',
										'list',
										'listItem',
										'code',
									]}
									unwrapDisallowed={true}
								>
									{data.body}
								</ReactMarkdown>
							</div>
						</div>
					</div>
				)}
			</div>
		)
	},
	(prevProps, nextProps) =>
		prevProps.data.id === nextProps.data.id &&
		prevProps.data.textHeight === nextProps.data.textHeight &&
		prevProps.data.$layout === nextProps.data.$layout &&
		prevProps.data.$detailLevel === nextProps.data.$detailLevel &&
		prevProps.style.top === nextProps.style.top
)
FinalSituationCard.displayName = 'FinalSituationCard'
FinalSituationCard.defaultHeight = 130
FinalSituationCard.defaultSummaryHeight = 50
FinalSituationCard.contentDefaultHeight = 1.5

export default FinalSituationCard
